import React, { useEffect, useState } from 'react';
import GlobalDialog from '../../../components/mui/Dialogue/GlobalDialog';
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { ViewButton } from '../../../components/mui/Buttons/Buttons';
import { useDispatch } from 'react-redux';
import { getQuotationRequirements, getQuotationsOfRequrements } from '../../../redux/features/assetManagementSlice';
import { useSelector } from 'react-redux';
import SimpleLoader from '../../../components/Loader/SimpleLoader';
import ToolTip from '../../../components/ToolTip/ToolTip';
import DeleteQuotation from './DeleteQuotation';
import NoDataFound from '../../../components/NodataIndication/NoDataFound';
import ApproveQuotation from './ApproveQuotation';
import AddOrUpdatePurchase from '../purchase/AddOrUpdatePurchase';
import { Icon } from '@iconify/react/dist/iconify.js';
import StatusChangeWithRemarksQuotation from './StatusChangeWithRemarksQuotation';
import ViewAttachment from './ViewAttachment';
const ViewQuotationsOfRequirements = ({ row, dispatchParams, isApproval, isEditable, productName }) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { loading, quotationsData } = useSelector((store) => store.assetmanagement);
  const handleCancel = () => {
    setOpen(false);
    dispatch(getQuotationRequirements(dispatchParams));
  };

  useEffect(() => {
    if (open) {
      dispatch(getQuotationsOfRequrements(row.requirementID));
    }
  }, [open]);

  const afterSuccessStatusChange = () => {
    dispatch(getQuotationsOfRequrements(row.requirementID));
  };
  return (
    <GlobalDialog
      maxWidth={'lg'}
      fullWidth={true}
      title={'Quotations'}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      popupButton={
        <>
          <ViewButton
            variant="outlined"
            size="small"
            sx={{ backgroundColor: '#7faddb', color: '#b43131' }}
            action={() => setOpen(true)}
          >
            Quotations
          </ViewButton>
        </>
      }
      content={
        <>
          <Box>
            {loading ? (
              // <Box
              //   sx={{
              //     position: 'absolute',
              //     top: 0,
              //     left: 0,
              //     width: '100%',
              //     height: '100%',
              //     bgcolor: 'rgba(255,255,255,0.6)',
              //     display: 'flex',
              //     justifyContent: 'center',
              //     alignItems: 'center',
              //     zIndex: 10,
              //   }}
              // >
              <SimpleLoader />
            ) : // </Box> */}
            quotationsData.length == 0 ? (
              <NoDataFound />
            ) : (
              <TableContainer
                sx={{
                  border: '1px solid #ccc',
                }}
              >
                <Table sx={{ minWidth: 650, borderCollapse: 'collapse' }}>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ width: 90, borderRight: '1px solid #ccc' }} align="center">
                        SL No
                      </TableCell>
                      <TableCell sx={{ width: 200, borderRight: '1px solid #ccc' }} align="center">
                        Quotation ID
                      </TableCell>
                      <TableCell sx={{ width: 200, borderRight: '1px solid #ccc' }} align="center">
                        Product Name
                      </TableCell>
                      <TableCell sx={{ width: 300, borderRight: '1px solid #ccc' }} align="center">
                        Vendor Name
                      </TableCell>
                      <TableCell sx={{ width: 300, borderRight: '1px solid #ccc' }} align="center">
                        Cost Per Item
                      </TableCell>
                      <TableCell sx={{ width: 300, borderRight: '1px solid #ccc' }} align="center">
                        Quantity
                      </TableCell>
                      <TableCell sx={{ width: 300, borderRight: '1px solid #ccc' }} align="center">
                        GST Amount
                      </TableCell>
                      <TableCell sx={{ width: 300, borderRight: '1px solid #ccc' }} align="center">
                        Courier Charge
                      </TableCell>
                      <TableCell sx={{ width: 300, borderRight: '1px solid #ccc' }} align="center">
                        Discount Amount
                      </TableCell>

                      <TableCell sx={{ width: 300, borderRight: '1px solid #ccc' }} align="center">
                        Total Cost
                      </TableCell>
                      <TableCell sx={{ width: 300, borderRight: '1px solid #ccc' }} align="center">
                        Delivery Date
                      </TableCell>

                      <TableCell sx={{ width: 300, borderRight: '1px solid #ccc' }} align="center">
                        Payment Type
                      </TableCell>
                      <TableCell sx={{ width: 300, borderRight: '1px solid #ccc' }} align="center">
                        No Of Installment
                      </TableCell>
                      <TableCell sx={{ width: 500, borderRight: '1px solid #ccc' }} align="center">
                        Installment Amounts
                      </TableCell>
                      <TableCell sx={{ width: 300, borderRight: '1px solid #ccc' }} align="center">
                        Recommended
                      </TableCell>
                      <TableCell sx={{ width: 300, borderRight: '1px solid #ccc' }} align="center">
                        Quotation Status
                      </TableCell>
                      <TableCell sx={{ width: 300, borderRight: '1px solid #ccc' }} align="center">
                        Hold / Reject Remarks
                      </TableCell>
                      <TableCell sx={{ width: 500, borderRight: '1px solid #ccc' }} align="center">
                        Purchase Status
                      </TableCell>
                      <TableCell sx={{ width: 500, borderRight: '1px solid #ccc' }} align="center">
                        Attached File
                      </TableCell>
                      <TableCell sx={{ width: 500, borderRight: '1px solid #ccc' }} align="center">
                        Delete Quotation
                      </TableCell>
                      <TableCell sx={{ width: 500, borderRight: '1px solid #ccc' }} align="center">
                        Approve Quotation
                      </TableCell>
                      <TableCell sx={{ width: 500, borderRight: '1px solid #ccc' }} align="center">
                        Hold / Reject Quotation
                      </TableCell>
                      <TableCell sx={{ width: 500, borderRight: '1px solid #ccc' }} align="center">
                        Purchase
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {quotationsData.map((obj, index) => (
                      <TableRow key={obj.sl_no}>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #ccc',
                            fontWeight: 'bold',
                          }}
                          align="center"
                        >
                          {obj.sl_no}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #ccc',
                            fontWeight: 'bold',
                          }}
                          align="center"
                        >
                          {obj.quotationID}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #ccc',
                            fontWeight: 'bold',
                          }}
                          align="center"
                        >
                          {productName}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #ccc',
                          }}
                          align="center"
                        >
                          {obj.vendor_details.name}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #ccc',
                          }}
                          align="center"
                        >
                          {obj.cost}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #ccc',
                          }}
                          align="center"
                        >
                          {obj.quantity}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #ccc',
                          }}
                          align="center"
                        >
                          {obj.gst}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #ccc',
                          }}
                          align="center"
                        >
                          {obj.courierCharge}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #ccc',
                          }}
                          align="center"
                        >
                          {obj.discountAmount}
                        </TableCell>

                        <TableCell
                          sx={{
                            borderRight: '1px solid #ccc',
                          }}
                          align="center"
                        >
                          {obj.totalCost}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #ccc',
                          }}
                          align="center"
                        >
                          {obj.deliveryDate}
                        </TableCell>

                        <TableCell
                          sx={{
                            borderRight: '1px solid #ccc',
                          }}
                          align="center"
                        >
                          {obj.paymentType == 1 ? 'Non-Installment' : 'Installment'}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #ccc',
                          }}
                          align="center"
                        >
                          {obj.installmentCount}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #ccc',
                          }}
                          align="center"
                        >
                          {obj.quotation_installments.length > 0 ? (
                            <ToolTip
                              expand={obj.quotation_installments.map((data) => data.amount).join(', ')}
                              content={obj.quotation_installments.map((data) => data.amount).join(', ')}
                            />
                          ) : (
                            'Nill'
                          )}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #ccc',
                          }}
                          align="center"
                        >
                          {obj.isRecommended ? 'YES' : 'NO'}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #ccc',
                          }}
                          align="center"
                        >
                          {obj.quotationStatus == 2 ? (
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                            >
                              <Icon
                                icon="fluent:text-change-reject-20-filled"
                                width="20"
                                height="20"
                                style={{ color: '#eb0000', marginRight: '4px' }}
                              />
                              Rejected
                            </Box>
                          ) : obj.quotationStatus == 1 ? (
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                            >
                              <Icon
                                icon="icon-park-twotone:success"
                                width="20"
                                height="20"
                                style={{
                                  color: ' #2acc1e',
                                  marginRight: '4px',
                                }}
                              />
                              Approved
                            </Box>
                          ) : obj.quotationStatus == 3 ? (
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                            >
                              <Icon
                                icon="hugeicons:hold-03"
                                width="20"
                                height="20"
                                style={{
                                  color: ' #2acc1e',
                                  marginRight: '4px',
                                }}
                              />
                              Hold
                            </Box>
                          ) : (
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                            >
                              <Icon
                                icon="material-symbols:pending"
                                width="20"
                                height="20"
                                style={{
                                  color: ' #f1f139',
                                  marginRight: '4px',
                                }}
                              />
                              Pending
                            </Box>
                          )}
                        </TableCell>

                        <TableCell
                          sx={{
                            borderRight: '1px solid #ccc',
                          }}
                          align="center"
                        >
                          <ToolTip content={obj?.holdRemarks || 'Nill'} expand={obj?.holdRemarks || 'Nill'} />
                        </TableCell>

                        <TableCell
                          sx={{
                            borderRight: '1px solid #ccc',
                          }}
                          align="center"
                        >
                          {obj.isPurchased ? 'Purchased' : 'Not Purchased'}
                        </TableCell>

                        <TableCell
                          sx={{
                            borderRight: '1px solid #ccc',
                          }}
                          align="center"
                        >
                          {obj?.attachmentFileName ? (
                            <ViewAttachment attachmentFileName={obj.attachmentFileName} />
                          ) : (
                            <span style={{ color: 'gray', fontSize: '12px' }}>No Attachment</span>
                          )}
                        </TableCell>

                        <TableCell
                          sx={{
                            borderRight: '1px solid #ccc',
                          }}
                          align="center"
                        >
                          <DeleteQuotation
                            dispatchParams={dispatchParams}
                            quotationId={obj.quotationID}
                            requirementID={row.requirementID}
                            isClosed={row.is_viewed}
                            isEditable={isEditable}
                          />
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #ccc',
                          }}
                          align="center"
                        >
                          <ApproveQuotation
                            dispatchParams={dispatchParams}
                            quotationId={obj.quotationID}
                            requirementID={row.requirementID}
                            isClosed={row.is_checked}
                            isApproval={!obj.isApprover}
                          />
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #ccc',
                          }}
                          align="center"
                        >
                          <StatusChangeWithRemarksQuotation
                            dispatchParams={dispatchParams}
                            quotationId={obj.quotationID}
                            requirementID={row.requirementID}
                            isClosed={row.is_checked}
                            isApproval={!obj.isApprover}
                            row={obj}
                            afterSuccessStatusChange={afterSuccessStatusChange}
                          />
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #ccc',
                          }}
                          align="center"
                        >
                          <AddOrUpdatePurchase
                            quotationId={obj.quotationID}
                            quotationStatusNotApproved={obj.quotationStatus != 1}
                            isEditable={isEditable}
                            isPurchased={obj.isPurchased}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Box>
        </>
      }
    />
  );
};

export default ViewQuotationsOfRequirements;
